import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
import 'proxy-polyfill';

import $ from 'jquery';
import 'mdbootstrap/src/js/free/wow';
import 'mdbootstrap/src/js/free/forms-free';
import Pristine from 'pristinejs/src/pristine';
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import Cookies from 'js-cookie'

import env from 'env';
import FormInput from 'form';
import { ApiErrorException } from 'exceptions';
import { getUrlVars, Observable } from 'helpers';
import { initStyle, initText } from 'layout';
import { init_session_observer } from 'connector';

import 'main.scss';

if (env.sentry_dsn) {
  Sentry.init({
    dsn: env.sentry_dsn,
    environment: env.sentry_env,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const go401 = (data) => {
  const redirect = `${env.redirect401}/login/${data.public.project_name}?next=${window.location.pathname}`;
  if (env.production) {
    window.location.replace(redirect);
  } else {
    alert(redirect);
    console.log(redirect);
  }
};
const go404 = () => {
  if (env.production) {
    window.location.replace(env.redirect404);
  } else {
    alert('404');
  }
};

const go403 = () => {
  window.location.replace('/t/nosession');
}

$(() => {
  const [qs_kw, path_kw] = getUrlVars();
  console.log('QS', qs_kw);
  console.log('PATH', path_kw);
  if (!('public' in path_kw)) {
    go404();
    return;
  }
  $('.wow').wow();

  const $form = $('#welcome_form');
  const $mainLoader = $('#loader');
  const $formError = $('#form_error');
  const $connectSpinner = $('.connect .spinner-border');
  const $welcomeFormFieldsets = $('#welcome_form fieldset');
  const $view = $('#view');
  const $footer = $('#footer');
  const $splash = $('#splash');
  $splash.show();
  let formPristine;
  let publicId;
  let response_observable;
  let cookie;

  try {
    publicId = atob(path_kw['public'])
    if (!publicId.startsWith('v1')) {
      throw new Error('not a base64');
    }
  } catch {
    publicId = path_kw['public'];
  }

  fetch(`${env.apiUri}${env.apiPrefix}public/${publicId}/`)
    .then((res) => {
      if (!res.ok) {
        throw new ApiErrorException(res, res.statusText);
      }
      return res.json();
    })
    .then((data) => {
      if (data.public.require_auth) {
        return fetch(`${env.apiUri}${env.apiPrefix}me?project=${data.public.project_name}`)
          .then((res) => {
            if (!res.ok) {
              return go401(data)
            }
            return data;
          })
      } else {
        return new Promise((res, rej) => {
          res(data);
        })
      }
    })
    .then((data) => {

      let filledFieldsLength = 0;
      if (data.public.fields.length > 0) {
        initStyle(data.public.template_theme);
        initText(data.public, data.project);

        const [qs_kw, _] = getUrlVars();
        data.public.fields.reverse().forEach((f) => {

          const defaultValue = qs_kw[f.name] || f.default;
          const valuePresent = !!defaultValue;
          if (valuePresent) {
            filledFieldsLength += 1;
          }
          const el = new FormInput({
            name: f.name,
            label: f.label,
            active: valuePresent ? 'active' : '',
            type: f.type,
            required: f.required,
            defaultValue,
            value: defaultValue,
            validateMsg: {
              required: data.public.locales.text_required_error,
              // email: data.public.locales.validator_err_email,
              phone: data.public.locales.invalid_mobile_number,
            },
          });
          el.prependTo($form.find('fieldset'));
        });
      }

      formPristine = new Pristine($form[0], {
        classTo: 'form-group',
        errorClass: 'has-danger',
        successClass: 'has-success',
        errorTextParent: 'form-group',
        errorTextTag: 'div',
        errorTextClass: 'invalid-feedback',
      });

      const emailElem = document.getElementById("email");
      formPristine.addValidator(
        emailElem,
        function (value, el) {
          if (value?.length > 150) {
            return false
          }
          const emailRegex =  /^(?!.*,)\S+@\S+\.\S+$/i;
          return emailRegex.test(value);
        },
        data.public.locales.validator_err_email,
        2,
        true
      );

      response_observable = new Observable({data: null}, (k, v) => {
        if (k === 'data') {
          if (v.code === 429){
            $welcomeFormFieldsets.prop('disabled', false);
            $connectSpinner.hide();

            if ($('#welcome_form').is(':visible')) {
              $formError.text(data.public.locales.to_many_attempts_to_create_transaction).show();
            } else {
              window.alert(data.public.locales.to_many_attempts_to_create_transaction);
            }

          } else if (v.code !== 201) {
            $welcomeFormFieldsets.prop('disabled', false);
            $connectSpinner.hide();
            $formError.text(data.public.locales.create_session_general_error).show();

          } else {
            if (env.production) {
              window.location.replace(v.url);
            } else {
              alert(v.url)
              $welcomeFormFieldsets.prop('disabled', false);
              $connectSpinner.hide();
            }
          }
        }
      });

      if (data.public.fields.length === 0) {
        $form.trigger('submit');
      } else if ((filledFieldsLength === data.public.fields.length) && formPristine.validate()) {
        $form.trigger('submit');
      } else {
        $mainLoader.hide();
        $splash.hide();
        $view.show();
        $footer.show();
        $form.show();
      }

    })
    .catch((err) => {
      if (err instanceof ApiErrorException) {
        if (err.e.status === 404) {
          go404();
        } else if (err.e.status === 403) {
          go403();
        } else {
          response_observable.data = {code: 500};
        }
      } else {
        response_observable.data = {code: 500};
      }
    });

  $form.on('submit', function (e) {
    e.preventDefault();

    const values = $(this).serializeArray();
    const valid = formPristine.validate();
    const $formFeedback = $('.invalid-feedback');

    $formFeedback.show();
    $formError.text('').hide();

    if (valid) {
      let inputData = qs_kw || {}
      values.forEach((v) => {
        inputData[v.name] = v.value;
      });

      $formFeedback.hide();
      $welcomeFormFieldsets.prop('disabled', true);
      $connectSpinner.show();
      const headers = {'Content-Type': 'application/json'};
      const csrftoken = Cookies.get('csrftoken');
      if (!!csrftoken) {
        headers['X-CSRFToken'] = csrftoken;
      }
      const mode = (!!csrftoken && env.production) ? 'same-origin' : 'cors';
      fetch(`${env.apiUri}${env.apiPrefix}public/${publicId}/`, {
        method: 'POST',
        headers: headers,
        mode: mode,
        body: JSON.stringify({
          input_data: inputData,
        }),
      })
        .then(res => res.json())
        .then((data) => {
          if (['ws', 'sse'].includes(data.observer)) {
            init_session_observer(data.event.id, data.observer, response_observable)
          } else {
            response_observable.data = data
          }
        })
        .catch((err) => {
          response_observable.data = {code: 500};
        });
    }
  });
});
